export const API_URL = process.env.NODE_ENV === 'production' 
    ? window.location.origin 
    : `http://${window.location.hostname}:5001`;
